import React, { useState } from "react";
import { createPortal } from "react-dom";

export default function Tooltip({ children, title, body, placement = 'bottom' }) {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  const wrapperStyle = {
    display: "inline-block",
    cursor: "pointer",
    color: '#000000'
  };

  const tooltipBoxStyle = {
    position: "fixed", // 🔑 important for portal
    whiteSpace: "normal",
    padding: "10px",
    background: "var(--Gray-100, #F8F9FA)",
    color: "#212529",
    fontSize: "14px",
    borderRadius: "8px",
    zIndex: 10000,
    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.12)",
    textAlign: "left",
    width: "309px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "10px",
    border: "1px solid var(--Background-Gray, #E9ECEF)",
    transform: "translate(-50%, -100%)",
  };

  const arrowStyle = {
    // position: 'absolute',
    // bottom: '-6px',
    // left: '50%',
    // transform: 'translateX(-50%)',
    // width: 0,
    // height: 0,
    // borderLeft: '7px solid transparent',
    // borderRight: '7px solid transparent',
    // borderTop: '7px solid #fff',
    // filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.06))',

    position: 'absolute',
    top: '-1px',
    left: '-5px',
    width: 0,
    height: 0,
    borderLeft: '7px solid transparent',
    borderRight: '7px solid transparent',
    borderBottom: '7px solid rgb(255, 255, 255)',
    transform: 'rotate(-45deg)',
    filter: 'drop-shadow(rgba(0, 0, 0, 0.06) -2px -2px 6px)',
      
  };

    const titleStyle = {
    fontWeight: 600,
    marginBottom: '6px',
    fontSize: '15px',
    marginTop: 0,
  };

  const bodyStyle = {
    margin: 0,
    fontSize: '13px',
    color: '#212529',
    lineHeight: 1.54,
  };

  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    if (placement === 'top') {
      setPosition({
        top:  rect.top - 8,                  // just above the icon
        left: rect.left + rect.width / 2,    // horizontally centered
      });
    } else {
      setPosition({
        top:  rect.bottom + 8 + 65,
        left: rect.right  + 8 + 150,
      });
    }
    setVisible(true);
  };

  const handleMouseLeave = () => setVisible(false);

  return (
    <>
      <span
        style={wrapperStyle}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </span>

      {visible &&
        createPortal(
          <div
            style={{
              ...tooltipBoxStyle,
              top:  position.top,
              left: position.left,
              // For top placement the existing transform: translate(-50%,-100%) already
              // shifts the box above the anchor point, so no override needed.
            }}
          >
            {/* Arrow: points down when tooltip is above the icon */}
            <div style={placement === 'top' ? {
              position: 'absolute',
              bottom: '-7px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 0,
              height: 0,
              borderLeft: '7px solid transparent',
              borderRight: '7px solid transparent',
              borderTop: '7px solid #F8F9FA',
              filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.06))',
            } : arrowStyle} />
            {title && <p style={titleStyle}>{title}</p>}
            {body && <p style={bodyStyle}>{body}</p>}
          </div>,
          document.body
        )}
    </>
  );
}